import React from 'react';
import FieldView from "../../../../components/FieldView";
import {formDefFazendaLeite} from "../forms";
import {QuestionarioFazendaObject} from "../../../../models/Questionario";

interface QuestionarioLeiteV1Props {
  questionario: QuestionarioFazendaObject
}

const QuestionarioLeiteV1: React.FC<QuestionarioLeiteV1Props> = ({questionario}) => {
  return (
    <>
      <FieldView value={questionario.vacas_ordenhadas} def={formDefFazendaLeite.vacas_ordenhadas}/>
      <FieldView value={questionario.intervalo_entre_partos}
                 def={formDefFazendaLeite.intervalo_entre_partos}/>
    </>
  );
}

export default QuestionarioLeiteV1;
